<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New POS Transaction Type {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View POS Transaction Type - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit POS Transaction Type - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div v-if="customFormMode == 1">
                <!-- Normal -->
                <base-input alternative="" label="Code" placeholder="" v-model="postrntyp.code" input-classes="form-control" :disabled="is_system"/>
                <base-input alternative="" label="Name" placeholder="" v-model="postrntyp.name" input-classes="form-control" required />
                <base-input alternative="" label="Reference Code" placeholder="" v-model="postrntyp.ref_code" input-classes="form-control" required />
                <base-input label="Sequence No" required>
                    <a-input type="number" v-model="postrntyp.sequence_no" :disabled="viewMode" />
                </base-input>
                <base-input label="Upload Image">
                    <a-upload :action="uploadTransTypeLogo" listType="picture-card" :fileList="fileList" @preview="handlePreview" @change="handleChange" :headers="authHeaders" :disabled="viewMode">
                        <div v-if="fileList.length < 1 && imageLoaded == true"> +
                            <div class="ant-upload-text">Upload</div>
                        </div>
                    </a-upload>
                    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                        <img alt="example" style="width: 100%" :src="previewImage" />
                    </a-modal>
                </base-input>
                <base-input alternative="" label="Allowed Payment Types"  input-classes="form-control" >
                    <p style="text-indent: 5px; font-size: 11px;">At least one payment type should be selected (all payment types selected by default)</p>
                    <a-select
                        class="mb-5"
                        v-model="postrntyp.allowed_payment_types_id"
                        mode="multiple"
                        style="width: 100%"
                        placeholder="All Payment Types"
                        optionFilterProp="children"
                        @search="handlePaymentTypeSearch"
                        @change="getSelectedPaymentType"
                        :disabled="viewMode"
                        :filter-option="false"
                        :not-found-content="fetching ? undefined : null"
                        show-search
                        allowClear
                        >
                            <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                            <a-select-option v-for="payment in payment_types"
                                :key="payment.id"
                                :value="payment.id">{{ payment.name }}
                            </a-select-option>
                    </a-select>
                </base-input>
            </div>
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="color" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="postrntyp.code" input-classes="form-control"/>
                        <base-input alternative="" label="Name" placeholder="" v-model="postrntyp.name" input-classes="form-control" required />
                        <base-input label="Sequence No" required>
                            <a-input type="number" v-model="postrntyp.sequence_no"/>
                        </base-input>
                        <base-input label="Minimum Quantity" required>
                            <a-input type="number" v-model="postrntyp.min_qty"/>
                        </base-input>
                        <base-input label="Maximum Quantity" required>
                            <a-input type="number" v-model="postrntyp.max_qty"/>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="color" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>


            <div v-if="this.$attrs.viewMode != true">
                <div  v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import DynamicForm from '../DynamicForm.vue'
    
    import { mapState, mapActions } from 'vuex'
    import secureStorage from '../../controllers/secureStorage.js'
    var component_x;
    export default {
        components: {
            DynamicForm
        },
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType', 'publicUrl']),
        },
        mounted: async function () {

            const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/POS Transaction Type?field_name=name'  , null)
            const sytemModuleId = sytemModule.id
            const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId +'?field_name=system_module_id'  , null)
            if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
             const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
             if(accSystemModule != null){
                 if(accSystemModule.form_mode != undefined){
                     this.customFormMode = accSystemModule.form_mode
                 }
                 if(accSystemModule.customized_forms != undefined){
                     this.customForm = accSystemModule.customized_forms
                 }
             }
            }

            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            
            // const paymentType = await HTTPRequest.getRequest(this.endPoint.split("/api")[0] + "/api/v1/payment_types/?per_page=200", null)
            // this.payment_types = paymentType;
            // this.sort(this.payment_types);

            component_x = this
            if (component_x.profileId > 0){
                var transtype_data = await HTTPRequest.getRequest(component_x.endPoint + 'pos_transaction_types/' + component_x.profileId, null)
                if(transtype_data == undefined){
                    component_x.$router.go()
                } else {
                    if(transtype_data["error"] == undefined){
                        component_x.postrntyp = transtype_data
                        component_x.inputName = transtype_data["name"]
                        component_x.inputCode = transtype_data["code"]
                        component_x.is_system = transtype_data["is_system"]
                        let logo_img = transtype_data["image"]
                        this.fileList = [{
                                uid: transtype_data['id'],
                                name: transtype_data["name"],
                                status: 'done',
                                url: this.publicUrl + 'pos_transaction_types_images/' + logo_img
                            }]
                        if(this.postrntyp.allowed_payment_types_id == null) {
                            this.postrntyp.allowed_payment_types_id = []
                        } else {
                            this.postrntyp.allowed_payment_types_id = this.postrntyp.allowed_payment_types_id
                        } 

                        this.postrntyp.allowed_payment_types_id.forEach(async (value) => {
                            if (value !== this.allPaymentTypeId){
                                let payment_type = await HTTPRequest.getRequest(component_x.endPoint + 'payment_types/' + value, null)
                                this.payment_types.push({
                                    id: payment_type.id,
                                    name: payment_type.name,
                                    disabled: false
                                })
                            }
                        })
                    } else {
                        this.errors = transtype_data["error"].split(",");
                    } 
                }
            } 

            this.dynamicFormKey++;
        },
        data: function () {
            this.handlePaymentTypeSearch = _.debounce(this.handlePaymentTypeSearch, 800)
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                is_system: false,
                errors: [],
    
                customFormMode: 1,
                customForm: {},
                profileData: {},
                dynamicFormKey: 0,
                postrntyp: {},
                formErrors: [],
                payment_types: [],
                all_payments: null,
                fetching: false,
                lastFetchId: 0,
                // UPLOADER
                previewVisible: false,
                previewImage: '',
                fileList: [],
                imageLoaded: true,
                authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File" },
                viewMode: this.$attrs.viewMode 
            }
        },
        methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
                var formSettingsCopy = this.bagger
                var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
                this.formErrors = errors
                if(this.customFormMode == 3) {
                    this.errors = errors
                }
                this.bagger = mergedHash
            },
            isJsonString(str) {
                try {
                    var json = JSON.parse(str);
                    return (typeof json === 'object');
                } catch (e) {
                    return false;
                }
            },

            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.postrntyp.code, 0, 30));
                this.errors.push(ValidateField.required('Name', this.postrntyp.name));
                this.errors.push(ValidateField.charMinAndMax('Name', this.postrntyp.name, 0, 50));
                this.errors.push(ValidateField.numberOnlyFormat('Sequence Number', this.postrntyp.sequence_no));
                this.errors.push(ValidateField.required('Reference Code', this.postrntyp.ref_code));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            getSelectedPaymentType(value){
                this.postrntyp.allowed_payment_types_id = value;
            },
            handlePaymentTypeSearch (value) {
                this.fetching = true
                this.lastFetchId += 1;
                const fetchId = this.lastFetchId;

                fetch(this.endPoint + `payment_types?name=${value}`, {
                    headers: {
                    "Content-Type": "application/json",
                    "Authorization": 'Bearer ' + secureStorage.getItem("accessToken"), 
                    "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
                    }
                })
                .then(res => res.json())
                .then(res => {
                    if (fetchId !== this.lastFetchId) {
                        // for fetch callback order
                        return;
                    }
                    
                    this.payment_types = res.data.map(value => {
                        return {
                            id: value.id,
                            name: value.name,
                            disabled: false 
                        }
                    })

                    // this.payment_types.unshift({id: 0, name: ' All Payment Types'})
                    this.fetching = false
                })
            },
            create: async function () {
                if(!this.validateForm()) {
                    this.postrntyp.name = this.postrntyp.name.trim()
                    if (this.postrntyp.code != undefined)
                        this.postrntyp.code = this.postrntyp.code.trim()
                    this.postrntyp.status = 'A'

                    let file = null;
                    if(this.fileList.length > 0){
                        if (this.fileList[0].response == undefined){
                            file = this.fileList[0].name
                        } else {
                            file = this.fileList[0].response
                        }
                    }
                    this.postrntyp.image = file
                    
                    if(this.postrntyp.allowed_payment_types_id == undefined || this.postrntyp.allowed_payment_types_id.length == 0){
                        this.postrntyp.all_payments = 1
                        this.postrntyp.allowed_payment_types_id = null
                    } else {
                        this.postrntyp.all_payments = 0
                    }
                   
                    var groupPayload = { pos_transaction_types: this.postrntyp }

                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'pos_transaction_types', null, groupPayload)    
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                        this.$notification['success']({
                            message: 'Success',
                            description: "Pos Transaction Type successfully created."
                        });
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                            this.$notification['success']({
                                message: 'Success',
                                description: "Pos Transaction Type successfully Created."
                            });
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
        
                    this.postrntyp.name = this.postrntyp.name.trim()
                    if (this.postrntyp.code != undefined)
                        this.postrntyp.code = this.postrntyp.code.trim()
                    this.postrntyp.status = 'A'
                    
                    let file = null;
                    if(this.fileList.length > 0){
                        if (this.fileList[0].response == undefined){
                            file = this.fileList[0].name
                        } else {
                            file = this.fileList[0].response
                        }
                    }
                    this.postrntyp.image = file
                     
                    if(this.postrntyp.allowed_payment_types_id == undefined || this.postrntyp.allowed_payment_types_id.length == 0){
                        this.postrntyp.all_payments = 1
                        this.postrntyp.allowed_payment_types_id = null
                    } else {
                        this.postrntyp.all_payments = 0
                    }

                    var groupPayload = { pos_transaction_types: this.postrntyp }

                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'pos_transaction_types/' + this.profileId, null, groupPayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            },
            handleCancel () {
                this.previewVisible = false
            },
            handlePreview (file) {
                this.previewImage = file.url || file.thumbUrl
                // this.previewVisible = true
            },
            handleChange ({ fileList }) {
                this.fileList = fileList;
            },
            uploadTransTypeLogo() {
                return this.endPoint + 'pos_transaction_types/upload_image'
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
            });
      },
        }
    }
</script>

<style>
</style>
